import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    imagesTitle: { display: 'flex', alignItems: 'center', paddingBottom: 8 },
    imageTitle: {
      fontSize: 14,
      display: 'flex',
      gap: '8px',
    },
    inputHidden: { display: 'none' },
    checkbox: {
      color: `${palette.error.light} !important`,
      margin: '0px 6px 0px 0px !important',
      width: 5,
      height: 5,
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: `${palette.error.light} !important`,
      },
      '& .MuiSvgIcon-root': { width: '0.8em', height: '0.8em' },
    },
    helpIconImage: {
      width: 20,
      height: 20,
      color: palette.sideGray,
      cursor: 'pointer',
      marginRight: 3,
    },
    helpGrid: { display: 'flex' },
    previewBox: {
      height: 300,
      width: 300,
      border: '1px dashed #a6a8a3',
      borderRadius: 8,
      cursor: 'pointer',

      '& label': {
        cursor: 'pointer',
      },
      '& img': {
        maxWidth: '70%',
        backgroundColor: palette.white,
        objectFit: 'cover',
      },
    },
    activePreviewBox: {
      borderStyle: 'solid',
      backgroundColor: palette.lightGray,
    },
    dragAndDropTextContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',

      '& .MuiSvgIcon-root': {
        color: palette.sideGray,
      },
      '& .MuiTypography-root': {
        textAlign: 'center',
      },
    },
    additionalButton: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      alignItems: 'center',
    },
  });
